import React from 'react';
import { Route, Switch } from 'react-router-dom';
import constants from 'utils/constants';

const ACH = React.lazy(() => import(/* webpackChunkName: 'ACH' */ 'components/ach/ACH'));
const ImportReview = React.lazy(() =>
  import(/* webpackChunkName: 'ImportReview' */ 'components/ach/importReview/ImportReview')
);

const ACH_PATH = `${constants.WORKSPACES.PYMTCNTR}/ach`;

const ACHRoutes = () => (
  <Switch>
    <Route
      path={`${ACH_PATH}/create/:paymentType+`}
      component={() => <ACH action="create" />}
      exact
    />
    <Route
      path={`${ACH_PATH}/template-view/:achSenderId/:templateCode+`}
      component={() => <ACH action="template-view" />}
      exact
    />
    <Route
      path={`${ACH_PATH}/template-copy/:achSenderId/:templateCode+`}
      component={() => <ACH action="template-copy" />}
      exact
    />
    <Route
      path={`${ACH_PATH}/template-modify/:achSenderId/:templateCode+`}
      component={() => <ACH action="template-modify" />}
      exact
    />
    <Route
      path={`${ACH_PATH}/template-import-review/:pendingNumber/:batchSequence+`}
      component={() => <ImportReview action="template-import-review" />}
      exact
    />
    <Route
      path={`${ACH_PATH}/template/:paymentType+`}
      component={() => <ACH action="template" />}
      exact
    />
    <Route
      path={`${ACH_PATH}/import-review/:pendingNumber/:batchSequence+`}
      component={() => <ImportReview action="import-review" />}
      exact
    />
    <Route
      path={`${ACH_PATH}/:action/:id+`}
      component={(router) => <ACH action={router.match.params.action} />}
      exact
    />
    {/* TODO: Can be a specific missing route for ACH */}
    {/* <Route component={() => <h1>Can be a specific to payment center missing routes</h1>} /> */}
  </Switch>
);

export default ACHRoutes;
